import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    Card,
    Tabs,
    Row,
    Col,
    List as AntList,
    Empty,
    Upload,
    Icon,
    Button,
    Modal,
    Input,
    Tag,
    Checkbox,
    Typography,
    Select
} from "antd";

import {
    fetchDocumentsChecklist,
    uploadDocuments,
    fetchCaseDocuments,
    fetchCompanyDocuments,
    attachDocument,
    updateDocument,
    downloadApplicationForm,
    invalidateDocument,
    requestDocuments
} from "store/actions";
import { STATE_STATUS } from "constants";
import { List, OrderedMap } from "immutable";
import { LoaderSkeleton } from "components";
import { createDragSource, createDropTarget } from "hocs/drag-and-drop";
import { FILE_TYPE } from "constants/drag-drop-types";
import { getAuthToken } from "utilities/auth";
import { PermissionContextManager } from "hocs/permission-context-manager";
import { UI_PERMISSIONS } from "constants/index";
import { DocumentViewer } from "components/index";

const ListItem = AntList.Item;

const Dragger = Upload.Dragger;
const { Paragraph } = Typography;

const POST_SANCTION_REQUEST_DOCS = new OrderedMap({
    missingCheques: {
        label: "Missing Cheques",
        documentId: 34,
        key: "missingCheques",
        isFieldVisible: false
    },
    bankSignVerification: {
        label: "Bank Sign Verification",
        documentId: 28,
        key: "bankSignVerification",
        isFieldVisible: false
    },
    nach: {
        label: "NACH",
        documentId: 35,
        key: "nach",
        isFieldVisible: false
    },
    partnershipAuthorization: {
        label: "Partnership Authorization",
        documentId: 39,
        key: "partnershipAuth",
        isFieldVisible: false
    },
    vernacularDeclaration: {
        label: "Vernacular Declaration",
        documentId: 33,
        key: "vernacularDeclaration",
        isFieldVisible: false
    },
    shopPhotos: {
        label: "Shop Photos",
        documentId: 44,
        key: "shopPhotos",
        isFieldVisible: false
    },
    photos: {
        label: "Applicant Photo",
        documentId: 6,
        key: "photo",
        isFieldVisible: true,
        fieldType: "SELECT",
        options: [],
    },
    applicantESignPending: {
        label: "Applicant E-Sign Pending",
        documentId: 56,
        key: "applicantESignPending",
        isFieldVisible: true,
        fieldType: "SELECT",
        options: [],
    },
    any_other_1: {
        label: "Any Other",
        documentId: 41,
        key: "any_other_1",
        isFieldVisible: true,
        fieldType: "TEXT",
    },
    any_other_2: {
        label: "Any Other",
        documentId: null,
        key: "any_other_2",
        isFieldVisible: true,
        fieldType: "TEXT",
    }

});
class DirectFileUpload extends React.Component {
    state = {
        status: STATE_STATUS.IDLE
    };
    render() {
        return (
            <Upload
                {...{
                    directory: false, // Upload Directory Support
                    multiple: true, // Upload Multiple files support,
                    action:
                        `${process.env.BASE_URL}/company/documents/create/`,
                    showUploadList: false,
                    headers: {
                        Authorization: `Bearer ${getAuthToken().authToken}`
                    },
                    data: file => ({
                        file_name: file.name,
                        company: this.props.companyId
                    }),
                    onChange: ({ file }) => {
                        if (file.status === "uploading") {
                            this.setState({
                                status: STATE_STATUS.ENGAGED
                            });
                        }
                        if (file.status === "done") {
                            this.setState(
                                {
                                    status: STATE_STATUS.IDLE
                                },
                                () => this.props.uploadFiles([file.response])
                            );
                        }
                    }
                }}
            >
                <Button type={"default"} 
                    disabled={this.props.recreditViewOnlyPermission}
                >
                    Upload{" "}
                    <Icon
                        type={
                            this.state.status === STATE_STATUS.ENGAGED
                                ? "loading"
                                : "upload"
                        }
                        loading={this.state.status === STATE_STATUS.ENGAGED}
                    />
                </Button>
            </Upload>
        );
    }
}

DirectFileUpload.propTypes = {
    companyId: PropTypes.number,
    uploadFiles: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

const DragSourceCard = createDragSource({
    dragType: FILE_TYPE,
    canDrag: props => {
        return props.draggable ? props.draggable : true;
    },
    dragResponse: () => ({
        dragType: FILE_TYPE
    }),
    // eslint-disable-next-line no-unused-vars
    dropResult: (props, { dropEffect, ...result }) => {
        props.attachDocument(result.document, result.case, {
            ...result,
            file: props.fileId
        }, {
        refresh_page: false
    });
    }
})(Card);

class FileList extends React.Component {
    fileUpload = false;

    state = {
        fileName: null
    };

    getTitle = (file) => {
        return (
            <React.Fragment>
                <div className={"d-flex flex-direction-row justify-content-space-between"}>
                    <div style={{
                        textOverflow: "ellipsis",
                        overflow: "scroll"
                    }}>
                        <Paragraph
                            editable={!this.props.recreditViewOnlyPermission && {
                                onChange: (value) => {
                                    this.setState({
                                        fileName: value
                                    }, () => {
                                        this.props.changeName(
                                            file
                                                .set("file_name", this.state.fileName)
                                        );
                                    });
                                }
                            }}
                        >
                            {this.state.fileName || file.file_name + (file?.document?.document_name ? " (" + file?.document?.document_name + ")" : "")}
                        </Paragraph>
                    </div>
                </div>
                <div className={"d-flex flex-direction-row justify-content-space-between"}>
                    <Button className={"mr-5"} type={"link"} onClick={() => this.props.viewDoc(file)}>{"View"}</Button>
                    <Button className={"mr-5"} type={"link"} target={"_blank"} href={file.file}>{"Download"}</Button>
                    {this.props.isUserAllowedToEdit ? <Button type={"link"} onClick={() => {
                        this.props.invalidateDocument(
                            file
                        );
                    }} disabled={this.props.recreditViewOnlyPermission}>{"Delete"}</Button> : null}
                </div>
                {file.is_valid !== null && file.is_valid === false ?
                    <div>
                        <Tag color={"red"} className={"mr-5"}>
                            {"Rejected"}
                        </Tag>
                        {file.remarks}
                    </div>
                    : null
                }
            </React.Fragment>
        );
    }

    getStyle = (_) => {
        return _.is_valid !== null && _.is_valid === false ? {
            borderBottom: "2px solid red"
        } : null;
    }

    render() {
        if(!this.props.draggable) {
            return null;
        }
        return (
            <Card title={"Files"}>
                <Row>
                    <Col span={24} className={"mb-5"}>
                        <Dragger
                            {...{
                                directory: false, // Upload Directory Support
                                multiple: true, // Upload Multiple files support,
                                disabled:this.props.recreditViewOnlyPermission,
                                action:
                                    `${process.env.BASE_URL}/company/documents/create/`,
                                showUploadList: true,
                                headers: {
                                    Authorization: `Bearer ${
                                        getAuthToken().authToken
                                    }`
                                },
                                data: file => ({
                                    file_name: file.name,
                                    company: this.props.companyId
                                }),
                                onChange: ({ file }) => {
                                    if (file.status === "done") {
                                        this.props.uploadFiles([file.response]);
                                    }
                                }
                            }}
                        >
                            <p className="ant-upload-drag-icon">
                                <Icon type="inbox" />
                            </p>
                            <p className="ant-upload-text">
                                Click or drag file to this area to upload
                            </p>
                        </Dragger>
                    </Col>
                    <Col span={24}>
                        <AntList grid={{ column: 1 }}>
                            {!(
                                this.props.files && this.props.files.size > 0
                            ) ? (
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                ) : null}
                            {this.props.files
                                .map(_ => _.get("data"))
                                .sort((a, b) =>
                                    a.modified_date.isBefore(b.modified_date)
                                        ? 1
                                        : -1
                                )
                                .map(_ => (
                                    <ListItem style={this.getStyle(_)} key={_.id}>
                                        <DragSourceCard
                                            // type={"inner"}
                                            size={"small"}
                                            title={this.getTitle(_)}
                                            fileId={_.id}
                                            className={
                                                "padless-card no-shadow w-100"
                                            }
                                            draggable={!!this.props.draggable}
                                            attachDocument={
                                                this.props.attachDocument
                                            }
                                        />
                                    </ListItem>
                                ))}
                        </AntList>
                    </Col>
                </Row>
            </Card>
        );
    }
}

FileList.propTypes = {
    companyId: PropTypes.number,
    files: PropTypes.object,
    uploads: PropTypes.object,
    uploadFiles: PropTypes.func,
    attachDocument: PropTypes.func,
    draggable: PropTypes.bool,
    invalidateDocument: PropTypes.func,
    caseId: PropTypes.number,
    viewDoc: PropTypes.func,
    changeName: PropTypes.func,
    isUserAllowedToEdit: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
};

const DropTargetCard = createDropTarget({
    dropType: FILE_TYPE,
    dropResponse: props => {
        return {
            case: props.caseId,
            company: props.companyId,
            associate: props.associateId ? props.associateId : null,
            company_bank: props.bankId ? props.bankId : null,
            document: props.documentId,
            document_type: props.documentType
        };
    }
})(Card);

class DocumentsList extends React.Component {
    deactivateDocument = documentId => {
        const document = this.props.documents.find(_ => _.id === documentId);
        this.props.updateDocument(
            this.props.caseId,
            this.props.companyId,
            documentId,
            document.set("company", this.props.companyId).set("is_active", false).set("file", document.file && document.file.id).set("case" , this.props.caseId)
        );
    };
    uploadAndAttachFile = (documentId, documentType, files) => {
        const result = {
            case: this.props.caseId,
            company: this.props.companyId,
            associate: this.props.associateId ? this.props.associateId : null,
            company_bank: this.props.bankId ? this.props.bankId : null,
            document: documentId,
            document_type: documentType,
            is_valid: true
        };
        this.props.uploadFiles(files);
        files.map(_ =>
            this.props.attachDocument(result.document, result.case, {
                ...result,
                file: _.id
            })
        );
    };

    renderList = (_) => {
        return (
            <AntList itemLayout={"horizontal"}>
                {this.props.documents.filter(__ => __.document === _.id)
                    .size === 0 ? (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    ) : null}
                {this.props.documents
                    .filter(__ => __.document === _.id)
                    .sort((a, b) =>
                        a.modified_date.isBefore(b.modified_date)
                            ? 1
                            : -1
                    )
                    .map(__ => (
                        <ListItem
                            key={__.id}
                            actions={
                                this.props.deletable
                                    ? [
                                        <Button
                                            type="link"
                                            onClick={this.props.viewDocument.bind(
                                                null,
                                                __.file && __.file.id,
                                                __.file && __.file.file_name,
                                                __.file && __.file.file
                                            )}
                                            key={"view-button"}
                                        >
                                                View
                                        </Button>,
                                        <Button
                                            type="link"
                                            onClick={this.deactivateDocument.bind(
                                                null,
                                                __.id
                                            )}
                                            key={"deactivate-button"}
                                            disabled={this.props.recreditViewOnlyPermission}
                                        >
                                                Remove
                                        </Button>
                                    ] :
                                    [
                                        <Button
                                            type="link"
                                            onClick={this.props.viewDocument.bind(
                                                null,
                                                __.file && __.file.id,
                                                __.file && __.file.file_name,
                                                __.file && __.file.file
                                            )}
                                            key={"view-button"}
                                        >
                                            View
                                        </Button>
                                    ]
                            }
                        >
                            {__ && __.file && __.file.file_name}
                        </ListItem>
                    ))}
            </AntList>
        );
    }

    render() {
        return this.props.categories ? (
            this.props.categories.map(_ => (
                !this.props.droppable && this.props.documents.find(__ => __.document === _.id) ?
                    <DropTargetCard
                        type={"inner"}
                        className={"no-shadow mb-5"}
                        key={_.document_name}
                        title={_.document_name}
                        caseId={this.props.caseId}
                        companyId={this.props.companyId}
                        associateId={this.props.associateId}
                        bankId={this.props.bankId}
                        documentId={_.id}
                        documentType={_.document_type}
                        canDrop={() => this.props.droppable}
                        extra={this.props.deletable ? [
                            <DirectFileUpload
                                key={"direct-upload"}
                                companyId={this.props.companyId}
                                uploadFiles={this.uploadAndAttachFile.bind(
                                    null,
                                    _.id,
                                    _.document_type
                                )}
                                recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                            />
                        ] : null}
                    >
                        {this.renderList(_)}
                    </DropTargetCard> : this.props.droppable ? (
                        <DropTargetCard
                            type={"inner"}
                            className={"no-shadow mb-5"}
                            key={_.document_name}
                            title={_.document_name}
                            caseId={this.props.caseId}
                            companyId={this.props.companyId}
                            associateId={this.props.associateId}
                            bankId={this.props.bankId}
                            documentId={_.id}
                            documentType={_.document_type}
                            canDrop={() => this.props.droppable}
                            extra={this.props.deletable ? [
                                <DirectFileUpload
                                    key={"direct-upload"}
                                    companyId={this.props.companyId}
                                    uploadFiles={this.uploadAndAttachFile.bind(
                                        null,
                                        _.id,
                                        _.document_type
                                    )}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />
                            ] : null}
                        >
                            {this.renderList(_)}
                        </DropTargetCard>
                    ) : null
            ))
        ) : (
            <Empty />
        );
    }
}

DocumentsList.propTypes = {
    droppable: PropTypes.boolean,
    deletable: PropTypes.boolean,
    isOver: PropTypes.boolean,
    categories: PropTypes.array,
    documents: PropTypes.object,
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    associateId: PropTypes.number,
    bankId: PropTypes.number,
    updateDocument: PropTypes.func,
    uploadFiles: PropTypes.func,
    attachDocument: PropTypes.func,
    viewDocument: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
};


DocumentsList.defaultProps = {
    isRiskApprover: false
};

class PostSanctionDocumentsTab extends React.Component {
    state = {
        checklistTabs: List([]),
        fileViewId: null,
        fileName: null,
        fileUrl: null,
        selectedSanctionType: "post-sanction",
        showDoc: false,
        showRemarks: false,
        remarks: null,
        selectedFile: null,
        requestModal: false,
        requestedDocs: {
            document: [],
            documents: []
        }
    };
    async handleChecklistFetch() {
        if (
            this.props.caseId &&
            (!this.props.checklist ||
                this.props.checklist.getIn([this.state.selectedSanctionType, this.props.caseId,"status"]) === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchDocumentsChecklist(
                this.props.caseId,
                this.state.selectedSanctionType
            );
        }
    }
    async handleFilesFetch() {
        if (
            this.props.companyId &&
            (!this.props.files ||
                this.props.files.get("status") === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchCompanyDocuments(
                this.props.caseId,
                this.props.companyId
            );
        }
    }
    async handleDocumentsFetch() {
        if (
            this.props.caseId &&
            (!this.props.documents ||
                this.props.documents.get("status") === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchCaseDocuments(
                this.props.caseId,
                this.props.companyId
            );
        }
    }

    componentDidMount() {
        this.handleChecklistFetch();
        this.handleDocumentsFetch();
        this.handleFilesFetch();
    }

    componentDidUpdate() {
        this.handleChecklistFetch();
        this.handleDocumentsFetch();
        this.handleFilesFetch();
    }
    isLoading = () => {
        if (
            !this.props.documents ||
            this.props.documents.get("status") !== STATE_STATUS.FETCHED
        ) {
            return true;
        }
        if (
            !this.props.files ||
            this.props.files.get("status") !== STATE_STATUS.FETCHED
        ) {
            return true;
        }
        if (
            !this.props.checklist ||
            this.props.checklist.getIn([this.state.selectedSanctionType, this.props.caseId,"status"]) !== STATE_STATUS.FETCHED
        ) {
            return true;
        }
        return false;
    };
    viewDocument = (fileViewId = null, fileName = null, fileUrl = null) => {
        this.setState({
            visible: fileViewId ? true : false,
            fileViewId,
            fileName,
            fileUrl
        });
    };

    changeSanctionType = val => {
        this.setState({
            selectedSanctionType: val
        }, () => {
            this.handleChecklistFetch();
        });
    }

    downloadFile = (application_form) => {
        this.props.downloadApplicationForm(this.props.caseId, application_form);
    }

    invalidateDoc = () => {
        this.setState({
            showDoc: false,
            showRemarks: false
        }, () => {
            this.props.invalidateDocument(
                this.props.companyId,
                this.state.selectedFile && this.state.selectedFile.id,
                this.state.selectedFile
                    .set("file_name", this.state.fileName)
                    .set("remarks", this.state.remarks),
                this.props.caseId
            );
        });
    }

    showDocument = () => {
        const url = this.state.selectedFile && this.state.selectedFile.file;
        if (["jpg", "jpeg", "gif", "bmp", "png"].includes(url && url.split(".").reverse()[0])) {
            return (<img width={"100%"} src={url} />);
        }
        return (<iframe width={"1000"} height={"1000"} src={url} />);
    }

    getName = () => {
        return (
            <Paragraph
                editable={{
                    onChange: (value) => {
                        this.setState({
                            fileName: value
                        });
                    }
                }}
            >
                {this.state.fileName}
            </Paragraph>
        );
    }

    openRequestModal = () => {
        this.setState({
            requestModal: true
        });
    }

    closeRequestModal = () => {
        this.setState({
            requestModal: false
        });
    }

    onChangeRequestDocs = (val) => {
        let docs = val.filter(_ => String(_).includes("single")).map(_ => _.split("-")[0]);
        this.setState({
            requestedDocs: {
                ...this.state.requestedDocs,
                documents: [...docs]
            }
        });
    }

    requestDocumentsHandler = () => {
        this.setState({
            requestModal: false
        }, () => {
            let data = {
                ...this.state.requestedDocs,
                document: this.state.requestedDocs.document && this.state.requestedDocs.document.map(_ => {
                    if(_.id == null) {
                        _.id = 41;
                    }
                    return _;
                })
            };
            this.props.requestDocuments(
                this.props.caseId,
                this.props.companyId,
                data,
                true
            );
        });
    }

    onSelectApplicantForRequestedDoc = (docId, associate) => {
        this.setState({
            requestedDocs: {
                ...this.state.requestedDocs,
                document: [
                    ...this.state.requestedDocs.document,
                    {
                        id: docId || 41,
                        associate: associate
                    }
                ]
            }
        });
    }

    onChangeRequestDocText = (docId, e) => {
        let docExists = this.state.requestedDocs.document.find(_ => _.id == docId);
        if(docExists) {
            let docs = this.state.requestedDocs.document.map(_ => {
                if(_.id == docId) {
                    _.file_name = e.target.value;
                }
                return _;
            });
            this.setState({
                requestedDocs: {
                    ...this.state.requestedDocs,
                    document: [
                        ...docs
                    ]
                }
            });    
        } else {
            this.setState({
                requestedDocs: {
                    ...this.state.requestedDocs,
                    document: [
                        ...this.state.requestedDocs.document,
                        {
                            id: docId,
                            file_name: e.target.value
                        }
                    ]
                }
            });
        }
    }

    render() {
        let caseAssociates = this.props.caseAssociates && this.props.caseAssociates.filter(_ => [1,2].includes(_.type));
        return (
            <React.Fragment>
                <Modal
                    visible={this.state.visible}
                    onCancel={this.viewDocument.bind(null, null, null, null)}
                    title={this.state.fileName}
                    okText={null}
                    cancelText={null}
                    width={700}
                >
                    <DocumentViewer
                        url={this.state.fileUrl}
                        loading={!this.state.fileUrl}
                        width={600}
                        height={800}
                    />
                </Modal>
                <Modal
                    visible={this.state.showDoc}
                    onCancel={() => {
                        if(this.props.isUserAllowedToEdit && this.state.selectedFile && (!this.state.selectedFile.is_valid || this.state.selectedFile.fileName !== this.state.fileName)) {
                            this.setState({
                                showDoc: false,
                                selectedFile: this.state.selectedFile
                                    .set("is_valid", true)
                                    .set("remarks", null)
                                    .set("file_name", this.state.fileName)
                            }, () => {
                                this.invalidateDoc();
                            });
                        } else {
                            this.setState({
                                showDoc: false
                            });
                        }
                    }}
                    onOk={() => {
                        if(this.props.isUserAllowedToEdit) {
                            this.setState({
                                showRemarks: true
                            });
                        } else {
                            this.setState({
                                showDoc: false
                            });
                        }
                    }}
                    title={this.state.fileName}
                    okText={"Reject"}
                    cancelText={"Accept"}
                    width={"fit-content"}
                >
                    <DocumentViewer
                        url={this.state.fileUrl}
                        width={600}
                        height={800}
                    />
                </Modal>
                <Modal
                    visible={this.state.showRemarks}
                    title={"Remarks"}
                    onOk={this.invalidateDoc}
                    onCancel={() => {
                        this.setState({
                            showRemarks: false,
                            showDoc: false
                        });
                    }}
                >
                    <Input.TextArea onChange={({target : {value}}) => {
                        this.setState({
                            remarks: value
                        });
                    }} />
                </Modal>
                <Modal
                    visible={this.state.requestModal}
                    onCancel={this.closeRequestModal}
                    title={"Request Documents"}
                    destroyOnClose
                    onOk={this.requestDocumentsHandler}
                >
                    <Checkbox.Group
                        style={{
                            width: "100%"
                        }}
                        onChange={this.onChangeRequestDocs.bind(null, )}
                    >
                        {POST_SANCTION_REQUEST_DOCS.map((_) => {
                            if(!_.isFieldVisible) {
                                return (
                                    <Col key={_.documentId} span={12}>
                                        <Checkbox
                                            className={"fb-50"}
                                            value={`${_.documentId}-"single"`}
                                        >
                                            {_.label}
                                        </Checkbox>
                                    </Col>
                                );
                            } else if(
                                _.isFieldVisible &&
                                _.fieldType === "SELECT"
                            ) {
                                return(
                                    <Col key={_.documentId} span={24} style={{
                                        paddingTop: "2px",
                                        paddingBottom: "2px"
                                    }} className={"d-flex justify-content-space-between"}>
                                        <Checkbox
                                            className={"fb-50"}
                                            value={_.documentId}
                                        >
                                            {_.label}
                                        </Checkbox>
                                        <Select
                                            className={"fb-50"}
                                            style={{
                                                minWidth: "200px"
                                            }}
                                            size={"small"}
                                            mode={"multiple"}
                                            dropdownMatchSelectWidth={false}
                                            onSelect={this.onSelectApplicantForRequestedDoc.bind(null, _.documentId)}
                                        >
                                            {caseAssociates.map((_, k) => (
                                                <Select.Option key={k} value={_.company_associate && _.company_associate.id}>
                                                    {`${_.company_associate && _.company_associate.first_name} ${_.company_associate && _.company_associate.last_name}`}
                                                </Select.Option> 
                                            ))}
                                        </Select>
                                    </Col>
                                );
                            } else if(
                                _.isFieldVisible &&
                                _.fieldType === "TEXT"
                            ) {
                                return(
                                    <Col key={_.documentId} span={24} style={{
                                        paddingTop: "2px",
                                        paddingBottom: "2px"
                                    }} className={"d-flex justify-content-space-between"}>
                                        <Checkbox
                                            className={"fb-50"}
                                            value={_.documentId}
                                        >
                                            {_.label}
                                        </Checkbox>
                                        <Input
                                            onChange={this.onChangeRequestDocText.bind(null, _.documentId)}
                                            className={"fb-50"}
                                            size={"small"}
                                            style={{
                                                minWidth: "200px"
                                            }}

                                        />
                                    </Col>
                                );
                            }
                        }).toList().toArray()}
                    </Checkbox.Group>
                </Modal>
                <LoaderSkeleton loading={this.isLoading()}>
                    <Row>
                        {this.props.isApplicationFormDownloadable ?
                            <Col span={24} className={"p-10 d-flex justify-content-space-between"}>
                                <div>
                                    <Button type={"link"} onClick={this.downloadFile.bind(null, false)}>Download Application Form (Blank)</Button>
                                    <Button type={"link"} onClick={this.downloadFile.bind(null, true)}>Download Application Form</Button>
                                </div>
                                {/* <Button type={"link"} onClick={this.openRequestModal}>
                                    Request Post Sanction Docs
                                </Button> */}
                            </Col>
                            : null
                        }
                        <Col span={16} className={"p-10"}>
                            <Tabs tabPosition={"left"} type={"line"}>
                                {(
                                    (this.props.checklist &&
                                        this.props.checklist.getIn([this.state.selectedSanctionType, this.props.caseId,"data"])) ||
                                    List([])
                                ).map(_ => {
                                    return (
                                        <Tabs.TabPane key={_.name} tab={_.name}>
                                            <Card
                                                className={
                                                    "no-border-transparent scroll-to-screen-height"
                                                }
                                                title={_.name}
                                            >
                                                {
                                                    <DocumentsList
                                                        categories={_.documents}
                                                        caseId={
                                                            this.props.caseId
                                                        }
                                                        companyId={
                                                            this.props.companyId
                                                        }
                                                        documents={this.props.documents
                                                            .get("data")
                                                            .map(_ =>
                                                                _.get("data")
                                                            )
                                                            .toList()}
                                                        droppable={
                                                            this.props
                                                                .DOCUMENTS_EDIT
                                                        }
                                                        deletable={
                                                            this.props
                                                                .DOCUMENTS_EDIT
                                                        }
                                                        updateDocument={
                                                            this.props
                                                                .updateDocument
                                                        }
                                                        attachDocument={
                                                            this.props
                                                                .attachDocument
                                                        }
                                                        uploadFiles={this.props.uploadDocuments.bind(
                                                            null,
                                                            this.props.caseId,
                                                            this.props.companyId
                                                        )}
                                                        viewDocument={
                                                            this.viewDocument
                                                        }
                                                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                                    />
                                                }
                                            </Card>
                                        </Tabs.TabPane>
                                    );
                                })}
                            </Tabs>
                        </Col>
                        <Col span={8} className={"p-10 scroll-to-screen-height"}>
                            <FileList
                                companyId={this.props.companyId}
                                caseId={this.props.caseId}
                                invalidateDocument={(file) => {
                                    this.setState({
                                        selectedFile: file.set("is_active", false),
                                        showRemarks: true,
                                        fileName: file.file_name
                                    });
                                }}
                                changeName={(file) => {
                                    this.setState({
                                        selectedFile: file,
                                        fileName: file.file_name
                                    }, () => {
                                        this.invalidateDoc();
                                    });
                                }}
                                viewDoc={(file) => this.viewDocument(
                                    file && file.id,
                                    file && file.file_name,
                                    file && file.file
                                )}
                                files={
                                    this.props.files &&
                                    this.props.files.get("data").toList()
                                }
                                isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                uploads={this.props.uploads || new List([])}
                                attachDocument={this.props.attachDocument}
                                uploadFiles={this.props.uploadDocuments.bind(
                                    null,
                                    this.props.caseId,
                                    this.props.companyId
                                )}
                                draggable={this.props.DOCUMENTS_EDIT}
                                recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                            />
                        </Col>
                    </Row>
                </LoaderSkeleton>
            </React.Fragment>
        );
    }
}

PostSanctionDocumentsTab.propTypes = {
    documentsType: PropTypes.string,
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    checklist: PropTypes.object,
    files: PropTypes.object,
    documents: PropTypes.object,
    uploads: PropTypes.object,
    company: PropTypes.object,
    fetchDocumentsChecklist: PropTypes.func,
    fetchCaseDocuments: PropTypes.func,
    fetchCompanyDocuments: PropTypes.func,
    uploadDocuments: PropTypes.func,
    attachDocument: PropTypes.func,
    updateDocument: PropTypes.func,
    DOCUMENTS_EDIT: PropTypes.bool,
    isRiskApprover: PropTypes.bool,
    location: PropTypes.object,
    downloadApplicationForm: PropTypes.func,
    isApplicationFormDownloadable: PropTypes.bool,
    invalidateDocument: PropTypes.func,
    isUserAllowedToEdit: PropTypes.bool,
    requestDocuments: PropTypes.func,
    docMasterList: PropTypes.array,
    docMasterListStatus: PropTypes.string,
    caseAssociates: PropTypes.array,
    recreditViewOnlyPermission: PropTypes.bool,
};

PostSanctionDocumentsTab.defaultProps = {
    isRiskApprover: true,
    isApplicationFormDownloadable: false
};

const mapStateToProps = (state, props) => ({
    checklist: state.documents.get("checklist"),
    files: state.documents.getIn(["company_documents", props.companyId]),
    documents: state.documents.getIn(["case_documents", props.caseId]),
    company: state.companies.getIn([props.companyId, "data"]),
    uploads: state.documents.getIn(["uploads", props.companyId]),
    isApplicationFormDownloadable : state.user.getIn(["permissions", "download_application_form"]),
    docMasterListStatus: state.documents.getIn([
        "documentsMasterList",
        "status"
    ]),
    docMasterList: state.documents.getIn(["documentsMasterList", "data"]),
    caseAssociates: state.caseDetails.getIn([props.caseId, "caseAssociates", "data"])
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchDocumentsChecklist,
            uploadDocuments,
            fetchCaseDocuments,
            fetchCompanyDocuments,
            attachDocument,
            updateDocument,
            downloadApplicationForm,
            invalidateDocument,
            requestDocuments
        },
        dispatch
    );

const ReduxWrappedComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(PostSanctionDocumentsTab);

export default PermissionContextManager({
    permission: UI_PERMISSIONS.POST_SANCTION_DOCUMENTATION_VIEW,
    propsPermissions: {
        DOCUMENTS_EDIT: UI_PERMISSIONS.POST_SANCTION_DOCUMENTATION_EDIT
    }
})(ReduxWrappedComponent);
